

export const Wrapper = props => {
    return props.children
}

// children prop holds all the content, 
// you are passing between the opening and closing tag 